/**
 * src/lib/api/sse.js — Shared SSE (Server-Sent Events) parsing
 *
 * Shared SSE parser used by chat + voice conversation flows.
 */

const MAX_RAW_BYTES = 512;

/**
 * Parse an SSE text chunk into structured events.
 * @param {string} text - Raw SSE text (may contain multiple events separated by \n\n)
 * @param {{onParseError?: (err: Error, raw: string, meta: {eventType: string}) => void}} [options]
 * @returns {Array<{type: string, data: object}>} Parsed events
 */
export function parseSSE(text, options = {}) {
  const { onParseError } = options;
  const events = [];
  const chunks = text.split('\n\n');
  for (const chunk of chunks) {
    if (!chunk.trim()) continue;
    let eventType = 'message';
    let data = '';
    for (const line of chunk.split('\n')) {
      if (line.startsWith('event: ')) eventType = line.slice(7).trim();
      else if (line.startsWith('data: ')) data = line.slice(6);
    }
    if (data) {
      try {
        events.push({ type: eventType, data: JSON.parse(data) });
      } catch (err) {
        if (typeof onParseError === 'function') {
          const raw = data.length > MAX_RAW_BYTES ? data.slice(0, MAX_RAW_BYTES) : data;
          try { onParseError(err, raw, { eventType }); } catch { /* observer must not break the parser */ }
        }
      }
    }
  }
  return events;
}
